import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import MinistriesPage from "@/pages/MinistriesPage";
import OutreachPage from "@/pages/OutreachPage";
import EventsPage from "@/pages/EventsPage";
import WatchPage from "@/pages/WatchPage";
import GivePage from "@/pages/GivePage";
import NewHerePage from "@/pages/NewHerePage";
import PrayerPage from "@/pages/PrayerPage";
import ServePage from "@/pages/ServePage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/ministries" element={<MinistriesPage />} />
            <Route path="/outreach" element={<OutreachPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/watch" element={<WatchPage />} />
            <Route path="/give" element={<GivePage />} />
            <Route path="/new-here" element={<NewHerePage />} />
            <Route path="/prayer" element={<PrayerPage />} />
            <Route path="/serve" element={<ServePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #27272A",
            color: "#fff",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
